// Reglas de seguridad para contraseñas de usuario.
// Se usan en SignUpContent (registro) y en el modal de "Cambiar contraseña" (Profile).
// El backend (server/routes/auth.js) aplica la MISMA regla de forma independiente:
// el frontend es solo para feedback visual, nunca sustituye la validación del servidor.

export const PASSWORD_RULES = [
  { key: 'length', label: 'Al menos 8 caracteres', test: pw => pw.length >= 8 },
  { key: 'upper',  label: 'Una letra mayúscula',    test: pw => /[A-Z]/.test(pw) },
  { key: 'lower',  label: 'Una letra minúscula',    test: pw => /[a-z]/.test(pw) },
  { key: 'number', label: 'Un número',              test: pw => /[0-9]/.test(pw) },
];

// Devuelve true solo si la contraseña cumple TODAS las reglas.
export function isPasswordValid(pw) {
  return PASSWORD_RULES.every(rule => rule.test(pw || ''));
}
  